// @flow
import React, { Component, Fragment } from 'react';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import UserTemplate from 'components/user/UserTemplate';
import UserHeadContainer from 'containers/user/UserHeadContainer';
import UserContentContainer from 'containers/user/UserContentContainer';

import { type Match } from 'react-router-dom';
import PageTemplate from '../components/base/PageTemplate';

type Props = {
  match: Match,
};

class User extends Component<Props> {
  render() {
    const { match } = this.props;
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <UserTemplate>
          {/* <UserHeadContainer username={match.params.username} type={match.params.tab || ''} /> */}
          <UserContentContainer />
        </UserTemplate>
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default User;



// WEBPACK FOOTER //
// ./src/pages/User.js